import { render, staticRenderFns } from "./BlogList.vue?vue&type=template&id=0a71e1de&scoped=true&"
import script from "./BlogList.vue?vue&type=script&lang=js&"
export * from "./BlogList.vue?vue&type=script&lang=js&"
import style0 from "./BlogList.vue?vue&type=style&index=0&id=0a71e1de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a71e1de",
  null
  
)

export default component.exports